import { AloftDate, FormType, ReportJSON } from '@aloft/toolkit-shared';

import { downloadRpti } from './downloadRpti.ts';
import { generateTkv2SfrepReport } from './generateTkv2SfrepReport.js';

type SaveRptiFileArgs = {
  effectiveDate: AloftDate | undefined;
  zipName: string;
  reportJSON: ReportJSON;
  pdfs: { name: string; blob: Blob }[];
  formType: FormType;
};

export async function saveRptiFile({
  effectiveDate,
  zipName,
  reportJSON,
  pdfs,
  formType,
}: SaveRptiFileArgs) {
  const tkv2SfrepReport = generateTkv2SfrepReport(effectiveDate, reportJSON, pdfs, formType);

  const blob = new Blob([tkv2SfrepReport], { type: 'application/xml' });

  await downloadRpti({
    xml: blob,
    zipName: zipName,
    pdfs,
  });
}
